import { DEVELOPMENT } from "config";
import { useAuth } from "contexts/auth.context";
import { useContext } from "react";

export default function DevelopmentFeature({ dev, children }) {
  const { isAdmin } = useAuth();

  let condition = DEVELOPMENT;

  if (!dev) condition = condition || isAdmin;

  if (condition) return children;
}
